import { defineRule, configure } from 'vee-validate';
import { required, email } from '@vee-validate/rules';

import { isValidCNPJ, isValidCPF, isValidDate, isValidFullName } from '../utils/validators';

export default defineNuxtPlugin((app) => {
  const rules = {
    required,
    email,
    cnpj: isValidCNPJ,
    cpf: isValidCPF,
    date_format: isValidDate,
    fullName: isValidFullName,
  };

  for (const [name, rule] of Object.entries(rules)) {
    defineRule(name, rule);
  }

  configure({
    generateMessage: ({ rule }) => app.vueApp.$nuxt.$i18n.t(`validations.errors.${rule?.name}`),
  });
});
